module.exports = __webpack_public_path__ + "static/petroweb-c6cf4a21916139e440b2aeade4451c93.png";